// extracted by mini-css-extract-plugin
module.exports = {"icon":"Spinner_icon__3hhr4","rotate":"Spinner_rotate__1PQnq"};